<template>
  <div class="sign_in">

    <div class="signinf">
      <div class="info">
        <h1>
          <img src="../assets/img/logo.jpg" />
          <span>风谷运输管理系统</span>
        </h1>

        <el-form class="entry" ref="loginForm" :model="form" :rules="rules" label-position="top">
          <el-form-item prop="username" label="用户名">
            <el-input placeholder="请在此输入用户名" v-model="form.username">
            </el-input>
          </el-form-item>
          <el-form-item prop="password" label="密码">
            <el-input placeholder="请在此输入密码" v-model="form.password" show-password>
            </el-input>
          </el-form-item>
          <el-form-item v-show="showYzm" class="yzm" prop="yzm" label="验证码">
            <el-input placeholder="请在此输入验证码" v-model="form.yzm">
            </el-input>
            <div class="code" ref="yzm" @click="getYzm">
              <!-- <img :src="`${IP}${yzmUrl}`" /> -->
              <img :src="`${yzmUrl1}`" />
            </div>
          </el-form-item>
        </el-form>

        <el-button type="primary" class="subbtn" @click="loginValidate('loginForm')">登录</el-button>

        <div class="tips">风谷TMS 版权所有</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  name: "Login",
  props: {
    msg: String,
  },
  data() {
    return {
      yzmUrl: '/fleet/login/captcha',
      yzmUrl1: '',
      uniqid: '',
      showYzm: false,
      form: {
        username: null,
        password: null,
        // yzm: 'dycdl',
      },
      form1: {
        phone: null,
        code: null,
      },
      btnTitle: '获取验证码',
      rules: {
        username: [{ required: true, message: "请填写用户名", trigger: "blur" }],
        password: [
          { required: true, message: "请填写密码", trigger: "blur" },
          { min: 6, message: "长度不小于 6 位", trigger: "blur" },
        ],
        // phone: [{ required: true, message: "请填写手机号", trigger: "blur" }],
        // code: [{ required: true, message: "请填写验证码", trigger: "blur" }],
        // yzm: [{ required: true, message: "请填写验证码", trigger: "blur" }],
      },
      beginClientX: 0 /*距离屏幕左端距离*/,
      mouseMoveState: false /*触发拖动状态  判断*/,
      maxWidth: "" /*拖动最大宽度，依据滑块宽度算出来的*/,
      confirmWords: "按住滑块，拖动到最右边" /*滑块文字*/,
      confirmSuccess: false /*验证成功判断*/,
      activeName: 'first',
      isClick: true,
      showCode: true
    };
  },
  methods: {
    ...mapMutations(["setUserInfo"]),
    loginValidate(fname) {
      console.log({ ...this.form });
      // console.log(this.$refs);
      this.$refs[fname].validate((valid) => {
        console.log(valid);
        if (valid) {
          this.logReq()
        }
      });
    },
    logReq() {
      const { username, password, yzm } = this.form
      const params = {
        username,
        password,
        code: yzm,
        is_verify: 0,
      }
      if (this.uniqid) {
        params['uniqid'] = this.uniqid
        params['is_verify'] = 1
      }
      this.post('login/dologin', params, ({ user, msg }) => {
        if (user && user.id) {
          // console.log({ ...user });
          this.setUserInfo(user);
          let path = 'index'
          const { user_group_id } = user
          if (![1].includes(user_group_id)) {
            path = 'admin/welcome'
          }
          this.$nextTick(() => {
            this.$router.push(path)
          })
        } else if (msg.includes('离职') || msg.includes('冻结')) {
          this.$message({
            type: 'error',
            message: msg,
          });
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
          // this.form.code = ''
          this.showYzm = true
          this.getYzm()
        }
      })
    },
    getYzm() {
      this.$set(this.form, 'yzm', undefined)
      this.post('captcha/get_captcha', {}, ({ data, msg }) => {
        if (msg == 'success' && data) {
          console.log({ ...data });
          const { src, uniqid } = data
          this.yzmUrl1 = src
          this.uniqid = uniqid
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
          // this.form.code = ''
          this.showYzm = true
          this.getYzm()
        }
      })
    },
  },
  mounted() { },
};
</script>

<style lang="less" scoped>
@vw: 100vw / 1920;
@vh: 100vh / 1080;

.sign_in {
  position: relative;
  z-index: 99;
  height: 100vh;
  background: url(../assets/img/login_bg.png) no-repeat bottom left;
  background-size: 1490px 820px;

  .signinf {
    position: absolute;
    right: calc(210 * @vw);
    top: calc(106 * @vw);
    width: 640px;
    height: 689px;
    overflow: hidden;
    background: #fff;
    box-shadow: 0px 19px 39px 1px #DEE1FF;
    border-radius: 30px;

    .info {
      width: 400px;
      height: auto;
      overflow: hidden;
      margin: 0 auto;

      h1 {
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        font-size: 28px;
        color: #2A1E17;
        margin: 50px auto;

        img {
          width: 63px;
          height: 56px;
          margin-right: 15px;
        }
      }

      /deep/ .el-tabs {
        .el-tabs__header {
          .el-tabs__item {
            font-weight: bold;
            font-size: 15px;
            padding: 0;
            height: 50px;

            &.is-active {
              color: #3E82FE;
            }
          }
        }
      }

      .entry {
        /deep/ .el-form-item {
          margin-bottom: 10px;

          .el-form-item__label {
            color: #2A1E17;
            padding: 0;

            &::before {
              display: none;
            }
          }

          .el-form-item__content {
            .el-input {
              .el-input__inner {
                border: 0 none;
                height: 50px;
                padding: 0 20px;
                background: #F5F5F5;
              }
            }

            .el-input__suffix {
              display: flex;
              align-items: center;
            }
          }
        }

        .yzm {
          /deep/ .el-form-item__content {
            display: flex;

            .code {
              width: 250px;
              height: auto;
              margin-left: 20px;
              display: flex;
              cursor: pointer;

              img {
                width: 100%;
                align-self: center;
              }
            }
          }
        }
      }

      .subbtn {
        display: block;
        width: 100%;
        height: 50px;
        line-height: 50px;
        text-align: center;
        overflow: hidden;
        margin: calc(70 * @vh) auto 0;
        padding: 0;
        border-radius: 5px;
        font-size: 16px;
        color: #fff;
        background: #4487EC;
      }

      .tips {
        width: 100%;
        text-align: center;
        font-size: 14px;
        color: #9FB4D9;
        position: absolute;
        bottom: calc(35 * @vh);
        left: 0;
      }
    }
  }
}
</style>